<template>
  <BaseCard>
    <DiscountInfo
      v-if="showDiscountInfo"
      @close="showDiscountInfo = false"
    />
    <Flex
      v-if="lastMinuteDiscounts && !$apollo.loading"
      justify="between"
    >
      <Flex direction="column">
        <BaseHeading>
          {{ $t('marketing.discounts.last_minute.title') }}
        </BaseHeading>
        <Flex
          direction="column"
          v-if="!lastMinuteDiscounts.enabled"
        >
          <BaseText>{{ $t('marketing.discounts.last_minute.body') }}</BaseText>
          <BaseText
            @click="showDiscountInfo = true"
            v-test="'lastMinuteDiscountInfo'"
          >
            {{ $t('marketing.discounts.more_tips') }}
          </BaseText>
        </Flex>
        <Flex
          direction="column"
          v-else
        >
          <BaseText>
            {{ $t('marketing.discounts.last_minute.body_enabled', {
                percentage: lastMinuteDiscounts.discountPercentage
              }) }}
            {{ $t(
                `marketing.discounts.booking_range.${lastMinuteDiscounts.discountWindow.toLowerCase()}`
              ).toLowerCase() }}
          </BaseText>
          <Flex :gap=".5">
            <BaseText
              :router-link="{ name: 'disable-last-minute-discount' }"
              v-test="'disableLastMinuteDiscounts'"
            >
              {{ $t('global.actions.disable') }}
            </BaseText>
            <BaseText
              :router-link="{ name: 'enable-last-minute-discount' }"
              v-test="'editLastMinuteDiscounts'"
            >
              {{ $t('global.actions.edit') }}
            </BaseText>
          </Flex>
        </Flex>
        <Flex>
          <BaseButton
            v-if="!lastMinuteDiscounts.enabled"
            color="inverted"
            @click="onEnableClick"
            v-test="'enableLastMinuteDiscounts'"
          >
            {{ $t('marketing.discounts.last_minute.enable') }}
          </BaseButton>
          <BaseAlert
            v-else-if="
            lastMinuteDiscounts.enabled && lastMinuteDiscounts.bookings.length
          "
            :text="`🎉 ${$t('marketing.discounts.last_minute.bookings', { amount: lastMinuteDiscounts.bookings }, lastMinuteDiscounts.bookings.length === 1 ? 1 : 2)}`"
            v-test="'discountAmount'"
          />
        </Flex>
      </Flex>
    </Flex>
    <BaseSpinner
      v-else
      inline
      mb
    />
  </BaseCard>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { defineComponent } from 'vue';
import DiscountInfo from '@/modules/marketing/modals/DiscountInfo.vue';

export default defineComponent({
  components: {
    DiscountInfo,
  },
  data() {
    return {
      showDiscountInfo: false,
    };
  },
  methods: {
    onEnableClick() {
      this.$router.push({ name: 'enable-last-minute-discount' });
    },
  },
  apollo: {
    lastMinuteDiscounts: {
      query: gql`
        query getLastMinuteDiscounts {
          lastMinuteDiscounts {
            enabled
            discountPercentage
            discountWindow
            bookings
          }
        }
      `,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  },
});
</script>
